import ApiService from "@/common/api/api.service";

const FNDCTService = {
  listar(porPagina = 0, pagina = 0) {
    return ApiService.get(`BoletoCDE?TamanhoDaPagina=${porPagina}&NumeroDaPagina=${pagina}`);
  },
  buscarPorId(id) {
    return ApiService.get(`BoletoCDE/${id}`);
  },
  salvar(form) {
    let result = [];
    if (!form.id) result = ApiService.post(`BoletoCDE`, { ...form });
    else result = ApiService.put(`BoletoCDE`, { ...form });
    return result;
  },
  excluir(id) {
    return ApiService.delete(`BoletoCDE?id=${id}`);
  },
};

export default FNDCTService;
